// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__U+f-r"};